import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  selectedIndex = 0;
  next(i){
    this.selectedIndex = i;
  }
  contactForm={
    name:'',
    nameE:false,
    email:'',
    emailE:false,
    phone:'',
    phoneE:false,
    message:'',
    messageE:false,
  }
  constructor(
    private toast: ToastrService,
    private http: HttpClient
  ) { }

  ngOnInit() {
  }

  valid(){
    return !this.contactForm.nameE && !this.contactForm.emailE && !this.contactForm.phoneE && !this.contactForm.messageE
  }

  send(){
    this.contactForm.nameE = this.validate(this.contactForm.name);
    this.contactForm.emailE = this.validateEmail(this.contactForm.email);
    this.contactForm.phoneE = this.validatePhone(this.contactForm.phone);
    this.contactForm.messageE = this.validate(this.contactForm.message);

    
    if(!this.valid()){
      this.toast.error("Please make sure the form is filled in correct value")
      return;
    }
      const body ={
        name: this.contactForm.name,
        email: this.contactForm.email,
        phone: this.contactForm.phone,
        message: this.contactForm.message,
      }
      this.http.post(`https://ino-email-c3sd2zaqha-as.a.run.app/enquiry`, body).subscribe(result=>{
        this.toast.success("Submit successful")
        this.contactForm={
          name:'',
          nameE:false,
          email:'',
          emailE:false,
          phone:'',
          phoneE:false,
          message:'',
          messageE:false,
        }

      })

  }

  validateEmail(value) {
    if ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))) {
      return false;
    }
    return true;
  }
  validatePhone(value) {
    if (value.length > 8 && value.length < 20) {
      return false;
    }
    return true;
  }

  validate(value) {
    if (!value) {
      return true;
    }
    return false;
  }

}
